import IconReusable from '../../components/IconReusable';

export const getTabConfig = (isPwa) => [
  {
    label: 'Home',
    path: isPwa ? '/pwa-main-menu' : '/',
    inactiveIcon: <IconReusable name="HomeOutlined" size={24}  />,
    activeIcon: <IconReusable name="HomeFilled" size={24}  />,
    key: 'home',
    visible: true,
  },
  {
    label: 'My Business',
    path: '/my-business',
    inactiveIcon: <IconReusable name="BusinessOutlined" size={24}  />,
    activeIcon: <IconReusable name="BusinessFilled" size={24}  />,
    key: 'my_business',
  },
  {
    label: 'My Network',
    path: '/my-network',
    inactiveIcon: <IconReusable name="Network" size={24}  />,
    activeIcon: <IconReusable name="NetworkFilled" size={24}  />,
    key: 'my_network',
  },
  {
    label: 'Benefits',
    path: '/benefits/mybenefits',
    inactiveIcon: <IconReusable name="BenefitsOutlined" size={24}  />,
    activeIcon: <IconReusable name="BenefitsOutlined" size={24}  />,
    key: 'my_benefits',
  },
  
  {
    label: 'Performance',
    path: '/my-performance/network-performance',
    inactiveIcon: <IconReusable name="PerformanceOutlined" size={24}  />,
    activeIcon:  <IconReusable name="PerformanceOutlined" size={24}  />,
    key: 'network_performance',
  },
];

